import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const RoleGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService).checkRole().pipe(
        switchMap((operatorRole) => {
            // If the user is not an operator...
            if (!operatorRole) {
                // Redirect to the prestadores page with a redirectUrl param
                const urlTree = router.parseUrl(`prestadores`);

                return of(urlTree);
            }
            return of(true);
        }
        ),

    );
};
